// @flow
import { PRODUCT_BREADCRUMB } from 'Client/cms/toolkit/constants';
import { ProductBreadcrumbLine } from 'Components/lines/product-breadcrumb-line/ProductBreadcrumbLine';
import { productBreadcrumbResolver } from './productBreadcrumb.resolver';

export const productBreadcrumbDescriptor = {
  name: PRODUCT_BREADCRUMB,
  component: ProductBreadcrumbLine,
  props: productBreadcrumbResolver.props,
  resolve: productBreadcrumbResolver.resolve,
};
